// Builds the 7xN calendar cell array for a given month, matching the original
// class-combination rules exactly (a "today" cell with no slots keeps both
// `no-slots` and `today` classes, same as the pre-redesign markup did).
export function buildCalCells(calDays, calYear, calMonth, todayISO, selectedDate, slotsByDateMap, onSelectDay) {
  return calDays.map((day, i) => {
    if (day === null) return { key: `e${i}`, day: null };
    const iso = `${calYear}-${String(calMonth + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    const isPast = iso < todayISO;
    const isSelected = iso === selectedDate;
    const hasSlots = !!slotsByDateMap[iso];
    let extraClass = '';
    if (isSelected) extraClass = 'selected';
    else if (isPast) extraClass = 'past';
    else if (!hasSlots) extraClass = 'no-slots';
    if (iso === todayISO && !isSelected) extraClass = extraClass ? `${extraClass} today` : 'today';
    return { key: iso, day, iso, extraClass, onClick: (!isPast && hasSlots) ? () => onSelectDay(iso) : null };
  });
}
